import React from "react";
import Icon from "./Icon";
export default function ZoomIn(props) {
  return /*#__PURE__*/React.createElement(Icon, props, /*#__PURE__*/React.createElement("path", {
    d: "M10.0833 17.4167C14.1334 17.4167 17.4167 14.1334 17.4167 10.0833C17.4167 6.03325 14.1334 2.75 10.0833 2.75C6.03325 2.75 2.75 6.03325 2.75 10.0833C2.75 14.1334 6.03325 17.4167 10.0833 17.4167Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.25 19.25L15.2625 15.2625"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.0834 7.33334V12.8333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.33337 10.0833H12.8334"
  }));
}
ZoomIn.displayname = "ZoomIn";
//# sourceMappingURL=ZoomIn.js.map